import { ConverterIF } from '@/components/Input/Converter/ConverterIF'
import '@/util/Extension/StringExtensions'

/**
 * 特定の文字列（shift-jis）の範囲内のみ許可するクラス
 */
export default class DesignSJISStringConverter implements ConverterIF {
    private strDesignText = "";

    constructor(strDesignText: string) {
        this.strDesignText = strDesignText;
    }

    /**
     * @brief	input要素のvalueの値を変換する
     * @param   [in]    target  対象のDOM情報
     * @return	変換後のvalue
     */
    public convertInputValue(target: HTMLInputElement): string {
        if (undefined == target || null == target) {
            return "";
        }

        if ("" === target.value) {
            return "";
        }

        // 制御コードを取り除く
        let strReturn = target.value.removeControlCode();

        // shift-jis以外を取り除く
        strReturn = strReturn.removeNotSJIS();

        if (0 < this.strDesignText.length) {
            // 特定の文字列を取り除く
            strReturn = strReturn.designString(this.strDesignText);
        }
        return strReturn;
    }

    /**
     * @brief	TextArea要素のvalueの値を変換する
     * @param   [in]    target  対象のDOM情報
     * @return	変換後のvalue
     */
    public convertTextAreaValue(target: HTMLTextAreaElement): string {
        // TextAreaには非対応のため空文字を返す。
        return "";
    }
}